import React from 'react';
import { getTurGradient, getSignTextColor } from '@/features/shared/utils/colors/elementColors';

interface TurBadgeProps {
    value: string;
    innerSignNumber?: number | null;
    surroundingSignNumber?: number | null;
    label?: string;
    className?: string;
}

export const TurBadge: React.FC<TurBadgeProps> = React.memo(({
    value,
    innerSignNumber,
    surroundingSignNumber,
    label,
    className = ""
}) => {
    if (!value || value === '-') return <span className="text-mystic-600">-</span>;

    const gradient = (innerSignNumber && surroundingSignNumber)
        ? getTurGradient(innerSignNumber, surroundingSignNumber).replace('background: ', '')
        : '';

    // Determine text color based on INNER sign (dominant)
    const textColor = innerSignNumber ? getSignTextColor(innerSignNumber) : 'text-white';

    return (
        <div
            title={label || ''}
            className={`mx-auto w-fit px-3 py-1 rounded-full ${textColor} font-bold text-xs shadow-md ${className}`}
            style={{ background: gradient || 'rgba(255,255,255,0.1)' }}
        >
            {value}
        </div>
    );
});
